// RightSidebar suppressed per user request
const RightSidebar = () => {
  return null;
};

export default RightSidebar;
